import React, { useState, useEffect } from 'react';
import { CssBaseline } from '@material-ui/core';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import AOS from 'aos';
import ReactGA from 'react-ga';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import 'antd/dist/antd.min.css';
import AppRoute from './routes/AppRoute';

ReactGA.initialize('UA-206896200-1');
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
	const [darkMode, setDarkMode] = useState(false);

	const theme = createTheme({
		palette: {
			type: darkMode ? 'dark' : 'light',
		},
	});

	useEffect(() => {
		AOS.init();
	}, []);
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<AppRoute darkMode={darkMode} setDarkMode={setDarkMode} />
		</ThemeProvider>
	);
}

export default App;
